<template>
  <h2>{{ title }}</h2>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style lang="scss" scoped>
h2 {
  color: #6c6c6c;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before,
  &:after {
    content: "";
    display: block;
    background: transparent url("../assets/direct-school-title-decoration.svg")
      no-repeat;
    width: 30px;
    height: 20px;
  }
}
</style>
